import { ShippingAddress } from "./ShippingAddress";
import { ShippingService } from "./ShippingService";

export const StandardDelivery = () => {
  return (
    <div
      className="tab-pane fade show active"
      id="pills-delivery"
      role="tabpanel"
      aria-labelledby="pills-delivery-tab"
    >
      <ShippingAddress />
      <ShippingService />
      {/* Shipping Method */}
    </div>
  );
};
